import React, { type JSX } from 'react';

import SVGIcon, { TIconType } from '../SVGIcon/SVGIcon';

import './styles/index.scss';

export interface Props {
  icon?: TIconType;
  label: string;
  onClick: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  className?: string;
  color?: 'primary' | 'secondary';
  size?: 'large';
}

const Button: React.FC<Props> = ({
  icon,
  label,
  onClick,
  disabled,
  className,
  color,
  size,
}: Props): JSX.Element => (
  <button
    type="button"
    className={`Button${className ? ` ${className}` : ''}${
      color ? ` Button_${color}` : ''
    }${size ? ` Button_${size}` : ''}`}
    onClick={onClick}
    disabled={disabled}
  >
    <span className="Button_inner">
      {icon && <SVGIcon icon={icon} className="Button_icon" />}
      <span className="Button_label">{label}</span>
    </span>
  </button>
);

export default Button;
